import { render, staticRenderFns } from "./FeedBackPopup.vue?vue&type=template&id=137f75d2&scoped=true&"
import script from "./FeedBackPopup.vue?vue&type=script&lang=js&"
export * from "./FeedBackPopup.vue?vue&type=script&lang=js&"
import style0 from "./FeedBackPopup.vue?vue&type=style&index=0&id=137f75d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137f75d2",
  null
  
)

export default component.exports